export default function miniSearchForm() {
    function initMiniSearchForm() {
        var miniSearchForm = $('form.mini-search-form');

        $(miniSearchForm).submit(function (e) {
            var query = {};

            var maker = $('select[name=maker] option:selected', miniSearchForm).text();

            if(maker != '' && maker != 'Marque') {
                query['dFR[maker.name][0]'] = maker;
            }

            var model = $('select[name=model] option:selected', miniSearchForm).text();

            if(model != '' && model != 'Modèle') {
                query['dFR[model.name][0]'] = model;
            }

            var price = $('input[name=price]', miniSearchForm).val();

            var isPriceSelectedSwitch = $('.switch-checkbox').prop('checked') == false;

            if(price != '' && isPriceSelectedSwitch) {
                var prices = price.split(';');

                if($('input[name=price]', miniSearchForm).data('min') != prices[0]) {
                    query['nR[pricing.price][>=][0]'] = prices[0];
                }

                if($('input[name=price]', miniSearchForm).data('max') != prices[1]) {
                    query['nR[pricing.price][<=][0]'] = prices[1];
                }
            }

            var monthlyPayment = $('input[name=monthlyPayment]', miniSearchForm).val();

            if(monthlyPayment != '' && monthlyPayment != undefined && ! isPriceSelectedSwitch) {
                var monthlyPayments = monthlyPayment.split(';');

                if($('input[name=monthlyPayment]', miniSearchForm).data('min') != monthlyPayments[0]) {
                    query['nR[funding.monthlyPayment][>=][0]'] = monthlyPayments[0];
                }

                if($('input[name=monthlyPayment]', miniSearchForm).data('max') != monthlyPayments[1]) {
                    query['nR[funding.monthlyPayment][<=][0]'] = monthlyPayments[1];
                }
            }

            var url = Routing.generate('vehicle_search', query);

            window.location.replace(url);

            return false;
        });
    }

    function switchPriceMensuality() {
        var $switch = $('input[name="switchPricesMiniForm"]');
        if ($switch.length) {

            if ($switch.is(':checked')) {
                switchToggle();
            }

            $switch.click(function () {
                switchToggle();
                resetToggle();
            });
        }
    }

    function switchToggle() {
        $('.switch').parent().parent().find('.tabPrices').toggleClass('hidden');
        $('.switch').parent().parent().find('.tabMensuality').toggleClass('active');
    }

    function resetToggle() {
        $('.switch').parent().parent().find('.tabPrices').find('select').val(null).trigger("change");
        $('.switch').parent().parent().find('.tabMensuality').find('select').val(null).trigger("change");
    }

    $(document).ready(function() {
        initMiniSearchForm();
        switchPriceMensuality();

        $('.firstLetterCapitalize .select2').on('click', function(e) {
            $('.select2-container').addClass('capitalize');
        });

    });
};


// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/app/mini-search-form.js